import SHSearch from "../../component/BMCSearch";
import {Col, Row, Table} from "react-bootstrap";
import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import Datatables from "../../component/Datatables";
import BMCDatePicker from "../../../components/common/BMCDatePicker";
import CustomDatePickerRange from "../../component/ui/DatePickerRange";
import axios from "axios";
import {toast} from "react-toastify";
import errorCodeDic from "../../../util/errorCodeDic";
import CustomDatePicker from "../../component/ui/DatePicker";
import BMCDatePicker2 from "../../../components/common/BMCDatePicker2";
import {DateHelper} from "../../../helper/DateHelper";
import BMCSelect from "../../../components/common/BMCSelect";

interface IProps {
   dataList: any;
   setSelData: Dispatch<SetStateAction<any>>;
   srchData: any;
   setSrchData: Dispatch<SetStateAction<boolean>>;
   isDatePopupOpen: boolean;
   setIsDatePopupOpen: Dispatch<SetStateAction<boolean>>;
   onSearch: any;
}

const SvrAcdntPnshmntByDprtPage = (props: IProps) => {
    const prodRef = useRef<any>();
    const [chkDt, setChkDt] = useState<Date>(DateHelper.dateByMonth(0));

    const fn_setSrchData = (e: any) => {

        props.setSrchData({
            ...props.srchData,
            [e.target.name]: e.target.value
        })


    }

    return(
        <>
            <SHSearch btnType={'p'} onSearch={props.onSearch}>
                <Row>
                    <Col>
                        <Table className="bmc-font-SP bmc-fs-b2 my-3">
                            <tbody>
                            <tr className="align-middle border-bottom">
                                <th className="bmc-bg-th">부서</th>
                                <td colSpan={2}>
                                    <div className="d-flex align-items-center w-100 gap-2" ref={prodRef}>
                                        <BMCSelect initOptionGb={'all'} name={'dprtCd'} codeGrpId={'D001'} className={"w-100"} codeGb={'cmmn'}
                                                   onChange={fn_setSrchData} value={props.srchData?.dprtCd}></BMCSelect>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </SHSearch>

            <div className={'ge-result'}>
                <Datatables
                    datas={props.dataList}
                    scrollY="550px"
                    className="bmc-fs-b4"
                    columns={[
                        {data: "dprtNm", title: "관리부서", render: (data: any) => {

                            if(!data){
                                return '시설관리처'
                            }else{
                                return data;
                            }

                            }},
                        {data: 'chkDt', title: '점검일자'},
                        {data: "title", title: "내용"},
                        {
                            data: "", title: "제출현황<br/>(제출 사업장/전체)", textAlign: 'center', render: (data: any, type: any, row: any) => {
                                console.log('row: ', row)

                                return row.sbmtSiteCnt + '/' + row.targetSiteCnt;
                            }
                        },

                    ]}
                    index={true}
                    checked={false}
                    onLoad={(dt: any) => {
                        //setDatatable(dt)
                    }}

                    onClick={(data) => {
                        props.setSelData(Object.assign({}, data));
                    }
                    }
                />


            </div>
        </>
        )

}

export default SvrAcdntPnshmntByDprtPage;
